module.exports = __webpack_public_path__ + "images/emoji/necktie.7946fd1c3d78ee8a769d.png";